import { Country } from './country';

const otherCountry = {
  label: 'Other',
  value: Country.Other,
};

const defaultCountries = [Country.US, Country.CA, Country.MX];

export { otherCountry, defaultCountries };
